import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sladetails',
  templateUrl: './sladetails.component.html',
  styleUrls: ['./sladetails.component.scss'],
})
export class SladetailsComponent {
  @Input() slaInfo: any | undefined; // Contains sub-objects from P1 to P4
  @Input() additionalInfo: object | undefined;

  objectValues = Object.values; // Used by the template

  constructor(private translate: TranslateService) {}

  /** Parse an SLA to go from the JSON data to a readable human stream
   * Maybe use a pipe instead ?
   */
  parseSLA(sla: string) {
    const convertedMinutes = parseInt(sla, 10);
    if (Number.isNaN(convertedMinutes)) {
      return sla;
    }

    if (convertedMinutes < 60){
      return `${convertedMinutes} minutes`;
    }
    // Show only relevant time slices
    return `${Math.floor(convertedMinutes / 60)}h` + (convertedMinutes % 60 !== 0 ? `${convertedMinutes % 60}min` : '');
  }
}
